var React = require('react');

function LongArowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Fill 1"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Azienda","transform":"translate(-753.000000, -1747.000000)","fill":"#C0C0C0"},React.createElement("g",{"id":"Section-/-storia","transform":"translate(479.000000, 1561.000000)"},React.createElement("polygon",{"id":"Fill-1","points":"313.955 186 313.955 334.654 277.995 298.933 274 302.954 316.79 345.46 359.579 302.954 355.583 298.933 319.625 334.654 319.625 186"}))))]);
}

LongArowDown.defaultProps = {"width":"86px","height":"160px","viewBox":"0 0 86 160","version":"1.1"};

module.exports = LongArowDown;

LongArowDown.default = LongArowDown;
